import React from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';

import propTypes from '../../../common/propTypes';
import RestrictedOperationConfirmationContent from './RestrictedOperationConfirmationContent';

@withRouter
export default class RestrictedOperationConfirmation extends React.PureComponent {
  static propTypes = {
    operationStatus: PropTypes.shape({
      pendingEmailConfirmation: PropTypes.bool.isRequired,
    }),
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func,
    updateMessageText: PropTypes.string,
    ...propTypes.routePropTypes,
  };

  static defaultProps = {
    operationStatus: null,
    onCancel: null,
    updateMessageText: null,
  };

  renderContent = ({ match, history }) => {
    const {
      match: rootMatch,
      operationStatus: passedOperationStatus,
      onConfirm,
      onCancel,
      updateMessageText,
    } = this.props;

    const operationStatus = passedOperationStatus || {
      pendingEmailConfirmation: false,
    };

    return (
      <RestrictedOperationConfirmationContent
        activeConfirmationToken={(match && match.params.token) || null}
        activeConfirmationType={(match && match.params.type) || null}
        baseRoute={rootMatch.url}
        history={history}
        pendingEmailConfirmation={operationStatus.pendingEmailConfirmation}
        updateMessageText={updateMessageText}
        onCancel={onCancel}
        onConfirm={onConfirm}
      />
    );
  };

  render() {
    const { match } = this.props;

    return (
      <Route path={`${match.url}/confirm/:type/:token?`}>
        {this.renderContent}
      </Route>
    );
  }
};
